export class Objectives{
    public id:string|undefined;
    public desc:string|undefined;

    constructor(id:string|undefined,desc:string|undefined) {
        this.id=id;
        this.desc=desc;
    }
}